<agr-page-toolbar
  [pageTitle]="'app.employee.module' | translate"
  [isEmpty]="emptyEmployees()"
  emptyTitle="{{ 'app.no_results_title' | translate }}"
  emptyDescription="{{ 'app.no_results_description' | translate }}"
  [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
>
  <ng-container actions>
    <app-search-field
      [value]="searchText()"
      [placeholderText]="'app.employee.search.placeholder' | translate"
      (searchValueChanged)="searchValueChanged($event)"
    ></app-search-field>
  </ng-container>
  <ng-container [agrBlockSpinner]="employees() === undefined">
    <agr-table-v2 [dataSource]="employeesDataSource" [withSelection]="false">
      <ng-container *agrTableFiltersWrapper></ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'app.employee.employees' | translate }}</th>
        <td mat-cell *matCellDef="let employee" data-test="employee-overview-item__name">
          <div class="overview-table__primary">{{ getName(employee) }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'app.employee.detail.email' | translate }}
        </th>
        <td mat-cell *matCellDef="let employee" data-test="employee-overview-item__email">
          {{ employee.email }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="overview-table__row"
        data-test="employee-overview__item"
        (click)="openEmployee(row)"
      ></tr>
      <tr *matNoDataRow>
        <td class="text--center" [attr.colspan]="displayedColumns.length">
          <agr-notification-empty
            [isEmpty]="true"
            emptyTitle="{{ 'app.no_results_title' | translate }}"
            emptyDescription="{{ 'app.no_results_description' | translate }}"
            [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
          ></agr-notification-empty>
        </td>
      </tr>
    </agr-table-v2>
  </ng-container>
</agr-page-toolbar>
